import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={80}
    height={80}
    viewBox="0 0 21.167 21.167"
    {...props}
  >
    <g id="backgroung-svg3" transform="translate(-.867 -.512) scale(1.0797)">
      <circle
        id="backgroung-svg"
        cx={10.571}
        cy={10.27}
        r={9.114}
        fill="none"
        stroke="#000"
        strokeLinecap="round"
        strokeWidth={1.323}
      />
      <circle cx={8.082} cy={7.653} r={1.455} />
      <path
        id="backgroung-svg2"
        fill="none"
        stroke="#000"
        strokeLinecap="round"
        strokeWidth={1.323}
        d="M6.868 14.672c1.871-3.426 6.045-3.413 7.622-.047"
      />
      <circle cx={13.373} cy={7.653} r={1.455} />
    </g>
  </svg>
)
export default SvgComponent
